import ProductCarouselCard from './ProductCarouselCard'

export default ProductCarouselCard
